import { queryOptions } from '@tanstack/react-query';
import { venueApi, type VenueScope } from './venue-api';

export const venueKeys = {
  all: ['merchant-venue'] as const,
  profile: (restaurantId: string) => [...venueKeys.all, 'profile', restaurantId] as const,
};

export const venueQueries = {
  profile: (scope: VenueScope) =>
    queryOptions({
      queryKey: venueKeys.profile(scope.restaurantId),
      queryFn: ({ signal }) => venueApi.get(scope, { signal }),
      // Idle until a branch is resolved (the branch list must load first).
      enabled: scope.restaurantId !== '',
    }),
};
